import type { MediaPreview, MediaType } from "./types";

const previewSize = 64;

function imageFileToPreview(file: File) {
  return new Promise<MediaPreview>((resolve) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = previewSize;
      canvas.height = previewSize;
      const context = canvas.getContext("2d");
      if (!context || !image.naturalWidth || !image.naturalHeight) {
        URL.revokeObjectURL(url);
        resolve({ kind: "image" });
        return;
      }

      const scale = Math.max(previewSize / image.naturalWidth, previewSize / image.naturalHeight);
      const width = image.naturalWidth * scale;
      const height = image.naturalHeight * scale;
      const x = (previewSize - width) / 2;
      const y = (previewSize - height) / 2;
      context.drawImage(image, x, y, width, height);
      URL.revokeObjectURL(url);
      resolve({ kind: "image", dataUrl: canvas.toDataURL("image/jpeg", 0.7) });
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      resolve({ kind: "image" });
    };
    image.src = url;
  });
}

export async function createMediaPreview(file: File | null, mediaType: MediaType): Promise<MediaPreview | undefined> {
  if (!file) return undefined;
  if (mediaType === "video") return { kind: "video" };
  return imageFileToPreview(file);
}
